/**
 *
 * CollaboratorsEdit
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { FormattedMessage } from "react-intl"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { pick } from "lodash"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import Loader from "components/Loader"
import CollaboratorsEditTemplate from "components/CollaboratorsEditTemplate"
import reducer from "./reducer"
import saga from "./saga"
import messages from "./messages"

import {
  MakeSelectDivisions,
  MakeSelectCategories,
  MakeSelectCurrency,
  makeSelectCollaborator,
  makeSelectIsLoadingCollaborator,
  MakeSelectLeaders,
  MakeSelectGenders,
  MakeSelectIsUpdating,
  makeSelectIsLoadingMeasures,
  makeSelectMeasuresAffected,
  MakeSelectLocations,
  makeSelectLanguage,
} from "./selectors"

import {
  removeCollaboratorWatcher,
  getMeasuresWatcher,
  getCollaboratorData,
  updateCollaboratorWatcher,
  getLanguageWatcher,
} from "./actions"

/* eslint-disable react/prefer-stateless-function */
export class CollaboratorsEdit extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.getCollaboratorData(this.props.match.params.id)
  }

  render() {
    const {
      divisions,
      categories,
      currency,
      isLoading,
      collaborator,
      updateCollaborator,
      genders,
      locations,
      leaders,
      history,
      removeCollaborator,
      isUpdating,
    } = this.props

    return (
      <React.Fragment>
        <Helmet>
          <title>Organización - Colaboradores</title>
          <meta name="description" content="Description of CollaboratorsEdit" />
        </Helmet>
        {isLoading ||
        !Array.isArray(divisions) ||
        !Array.isArray(categories) ? (
          <Loader />
        ) : (
          <CollaboratorsEditTemplate
            languages={this.props.languages}
            getLanguage={this.props.getLanguage}
            divisions={divisions}
            categories={categories}
            currency={currency}
            collaborator={collaborator}
            genders={genders}
            leaders={leaders}
            locations={locations}
            updateCollaborator={updateCollaborator}
            collaboratorId={this.props.match.params.id}
            history={history}
            removeCollaborator={removeCollaborator}
            isUpdating={isUpdating}
            {...pick(this.props, [
              "getMeasures",
              "isLoadingMeasures",
              "measuresAffected",
            ])}
          />
        )}
      </React.Fragment>
    )
  }
}

CollaboratorsEdit.propTypes = {}

const mapStateToProps = createStructuredSelector({
  collaborator: makeSelectCollaborator(),
  divisions: MakeSelectDivisions(),
  categories: MakeSelectCategories(),
  currency: MakeSelectCurrency(),
  isLoading: makeSelectIsLoadingCollaborator(),
  leaders: MakeSelectLeaders(),
  genders: MakeSelectGenders(),
  locations: MakeSelectLocations(),
  isUpdating: MakeSelectIsUpdating(),
  isLoadingMeasures: makeSelectIsLoadingMeasures(),
  measuresAffected: makeSelectMeasuresAffected(),
  languages: makeSelectLanguage(),
})

function mapDispatchToProps(dispatch) {
  return {
    getCollaboratorData: (params) => dispatch(getCollaboratorData(params)),
    updateCollaborator: (params) => dispatch(updateCollaboratorWatcher(params)),
    removeCollaborator: (params) => dispatch(removeCollaboratorWatcher(params)),
    getMeasures: (params) => dispatch(getMeasuresWatcher(params)),
    getLanguage: (params) => dispatch(getLanguageWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "collaboratorsEdit", reducer })
const withSaga = injectSaga({ key: "collaboratorsEdit", saga })

export default compose(withReducer, withSaga, withConnect)(CollaboratorsEdit)
